import React from "react";
import ReactApexChart from "react-apexcharts";


function ChartInvoice({ invoiceStatusByCurrentYearMonth }) {


  const Months =[];
  const Amounts =[];
  
  
  invoiceStatusByCurrentYearMonth?.forEach(item => {        
    Months.push(item.monthName);
    Amounts.push(item.totalAmount)
  });

  console.log("Months",Months)

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }

  const series = [

    {
      name: "Invoices Status",
      data: Amounts,
    },
  ];
  const options = {
    title:{
      text:"Invoice Status",
      align: "center"
    },
    chart: {
      zoom: { enabled: true },
      toolbar: {show: false},
    },
    dataLabels: {
      enabled: true,
      formatter: (value) => {
        return `${numberWithCommas(value)}`;
      },
    },
    legend: {
      show: false
    },    

    stroke: {
      curve: "smooth",
    },
    xaxis: {
      type: "string",
      categories: Months,
      name:"Months",
      title: {
        text: "Months",
      },
    },
    yaxis: {
    
     title: {
        text: "Amount",
      },  
      labels:{
        formatter: (value) => {
          return `${numberWithCommas(value)}`;
        },
      },   
    },
   
    tooltip: {
      x: {
        formatter: (value) => {
          return `${numberWithCommas(value)}`;
        },
      },
    },
    
  };

  return (
    <div
      style={{
        backgroundColor: "white",
        textAlign: "center",
        width: '90%',
        margin: '10px auto',
        padding: '10px'
      }}
    >
      <br />
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={300}
        
      />
    </div>
  );
}

export default ChartInvoice